module.exports = __webpack_public_path__ + "static/0032-46f6b890728e676c5411b25df8e0239b.png";